import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import Recall from '@elem/compPage/efdelta-recall-and-replacement';
import css from '@elem/compPage/efdelta-recall-and-replacement/page.module.scss';
import type { GetServerSidePropsContext } from 'next';
import Head from 'next/head';

const whiteLocaleList = ['jp'];

export default function Page({ SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const router = useRouter();
    const { t } = useLang('recall');

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <Head>
                <meta name="robots" content="noindex, nofollow" key="robots" />
                <meta name="googlebot" content="noindex, nofollow" key="googlebot" />
            </Head>
            <PageLayout className={`${css.recall}`}>
                <Recall />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
